
import {
  mdiTriangle,
  mdiCardsHeart,
  mdiPlus,
  mdiMinus,
  mdiEye,
  mdiEyeOff,
  mdiWeb,
} from "@mdi/js";
import { mapGetters, mapActions } from "vuex";
import Avatar from "~/components/ui/Avatar.vue";
import ProfileTags from "@/components/v2/profile-tags.vue";
import CBtn from "@/components/ui/button/c-btn.vue";
import IconPhoneDialogue from "@/components/icons/IconPhoneDialogue.vue";
import parsePhoneNumber from "libphonenumber-js/max";
import ProfileMenuV2 from "@/components/v2/common/profiles/profile-menu-v2.vue";
import IconMessage from "@/components/icons/IconMessage.vue";
import ProfileContactInfo from "@/components/v2/profile-contact-info.vue";
import LazyVideoIframe from "~/components/v2/ui/lazy-video-iframe.vue";
import {
  externalProfileLink,
  getLinkDomain,
  getMessengerLink,
} from "~/common/helpers";

export default {
  components: {
    Avatar,
    ProfileTags,
    CBtn,
    IconPhoneDialogue,
    ProfileMenuV2,
    IconMessage,
    ProfileContactInfo,
    LazyVideoIframe,
  },

  filters: {
    createLinkName(link) {
      if (link.startsWith("http")) {
        return link.split("//")[1].split("/")[0].replace("www.", "");
      } else if (!link.startsWith("@")) {
        return "@" + link;
      } else {
        return link;
      }
    },
  },

  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      mdiTriangle,
      mdiCardsHeart,
      mdiPlus,
      mdiMinus,
      mdiEye,
      mdiEyeOff,
      mdiWeb,

      hiddenCount: 6,
      inFavorites: false,
      isFullNunber: false,
      isFullContacts: false,
      isFavoriteProcessing: false,
      messengersForPrevent: ["Signal", "WeChat"],
    };
  },

  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
    }),

    profile() {
      return this.video.profile;
    },

    name() {
      return this.profile.name;
    },

    age() {
      return this.profile.age;
    },

    city() {
      return this.profile.city;
    },

    photo() {
      return this.profile.photo;
    },

    slug() {
      return this.profile.slug;
    },

    phone() {
      return this.profile.phone;
    },

    maskedNumber() {
      if (!this.phone) return "";
      const phone = parsePhoneNumber(this.phone)?.formatInternational();
      const visiblePart = phone.slice(0, -this.hiddenCount);
      const hiddenPart =
        '<span style="color: red; font-size: 14px; vertical-align: top;">' +
        "●".repeat(this.hiddenCount) +
        "</span>";
      return this.isFullNunber ? phone : visiblePart + hiddenPart;
    },

    messengers() {
      return this.profile.messengers || [];
    },

    links() {
      return this.profile.profile_links || [];
    },
  },

  mounted() {
    this.inFavorites = this.video.profile.isFavorite;
    this.isFullContacts = this.$device.isDesktop;
  },

  methods: {
    ...mapActions({
      addToFafourites: "profiles/addToFafourites",
      removeFromFavourites: "profiles/removeFromFavourites",
    }),

    externalProfileLink,

    getLinkDomain,

    getMessengerLink,

    openMessageDialog() {
      if (this.$auth.loggedIn) {
        this.isMenuOpen = false;
        this.$root.$emit("open-message-dialog", this.profile);
        return;
      }
      this.redirectOnAuth();
    },

    openBookMeModal() {
      this.$root.$emit("book-me-modal:open", this.profile.slug);
    },

    redirectOnAuth() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
        return;
      }
      this.$router.push({ name: "auth-signin" });
    },

    async processFavorite() {
      if (this.$auth.loggedIn) {
        this.isFavoriteProcessing = true;
        let response;
        if (this.video.profile.isFavorite) {
          response = await this.removeFromFavourites(this.video.profile.id);
        } else {
          response = await this.addToFafourites(this.video.profile.id);
        }

        if (response.data.status) {
          this.$store.commit("updates/setFavorite", this.video);
          this.inFavorites = !this.inFavorites;
        }

        if (!response.data.status) {
          this.$notify({
            type: "warning",
            message: response.data.msg,
          });
        }
        this.isFavoriteProcessing = false;
        return;
      }
      this.redirectOnAuth();
    },

    async copyPhone(e, messenger) {
      if (this.messengersForPrevent.includes(messenger)) {
        e.preventDefault();
        e.stopPropagation();

        await this.$copyText(this.phone, this.$refs.phoneContainer);
        this.$notify({
          type: "success",
          message: this.$t("phone-copied"),
        });
      }
    },
  },
};
